import React, { useState } from "react";
import "./Hospitality.css";
import "./Healthcare.css";

export default function Event() {
  const [activeIndex, setActiveIndex] = useState(0);

  const hospitalityData = [
    {
      title: "Techno Global Hospital ",
      heading: "Techno Global Hospital ",
      desc: `Equipped with modern facilities,
advanced equipment and state-of-the-art infrastructure, the hospital has touched more
than two million lives during the course of its prestigious journey. ​`,
      link: "#",
      bg: "/images/healthcare/rotary_techno_netralaya.jpg",
    },
    {
      title: "Techno Global Multispecialty & Oncology",
      heading: "Techno Global Multispecialty & Oncology",
      desc: `A 650-bedded, top-notch medical facility, Techno Global Multispeciality &
Oncology is committed to catering to the modern-day health requirements of the city.​`,
      link: "#",
      bg: "/images/healthcare/techno_global_multispecialty_&_oncology_hospital.jpg",
    },
    {
      title: "Rotary Techno Netralaya​",
      heading: "Rotary Techno Netralaya​",
      desc: `With more than six lakh happy patients, Rotary Techno Netralaya, Salt Lake happens to
be the go-to eye hospital in the city, for quality treatment at an affordable cost. ​`,
      link: "#",
      bg: "/images/healthcare/techno_global_hospital.jpg",
    },
  ];

  return (
    <>

      <div className="container-custom">

        {/* Top Banner */}
        <div className="media-top">
          <div>    <h2>Healthcare</h2></div>

          <div>
            <a href="/healthcare" className="learn-more">
              <i className="bi bi-arrow-right-circle-fill"></i>
              Learn more
            </a>
          </div>
        </div>

        {/* Hospitality Panels */}
        <div className="hospitality">
          <div className="containerr">

            {hospitalityData.map((item, index) => (
              <div
                key={index}
                className={`item-link ${activeIndex === index ? "active" : ""
                  }`}
                style={{ backgroundImage: `url(${item.bg})` }}
                onClick={() => setActiveIndex(index)}
              >
                {/* Sidebar Label */}
                <div className={`sidebar-form healthcare-sidebar-${index}`}>
                  {item.title}
                </div>
                <div></div>

                {/* Content */}
                <div className="item-contain">
                  <div className="item-contain-des">
                    <div className="banner">

                      <div className="left-box">
                        <h2>

                          {item.heading}

                        </h2>
                      </div>

                      <div className="right-box">
                        <p>{item.desc}</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>

    </>
  );
}
